import { useScanPartPhotoUpload } from '@/Client/Widgets/useScanPartPhotoUpload';

import type { FocusedGallerySection } from './gallerySections';

/** Reuses the Gallery's scan-part-aware image upload behavior. */
export const useGalleryPhotoUpload = (section: Pick<FocusedGallerySection, 'scanPart' | 'scanPartContext'>) =>
  useScanPartPhotoUpload(section.scanPart, section.scanPartContext);
